export default __webpack_public_path__ + "static/ism-home-desktop3-fbe776f76ed79b0a5f9c7df265b2ee31.png";